import React, { useEffect, useState } from 'react';
import instance from '../../services/services';
import { TERMS_LIST_URL } from '../../utils/urls';

function PrivacyPolicy() {
    const [termsList, setTermsList] = useState([]);

    useEffect(() => {
        const fetchTermsList = async () => {
            try {
                const response = await instance.post(TERMS_LIST_URL);
                setTermsList(response.data.data.policy_agreement);
            } catch (error) {
                console.error('약관 목록 가져오기 실패', error);
            }
        };
        fetchTermsList();
    }, []);
    
    return (
        <div className='inner column' style={{paddingTop:'80px',paddingBottom:'80px'}}>
            <div className='section_title'>
                <h3>개인정보처리방침</h3>
            </div>
            <div className='terms_list unset_box'>
                <div dangerouslySetInnerHTML={{ __html: termsList }} /> 
            </div>
        </div>
    );
}

export default PrivacyPolicy;